import styled from 'styled-components'

import Field from '../../components/Field'

const IconButtonFieldStyled = styled(Field)`
  cursor: pointer;
`
export default IconButtonFieldStyled
